export default function Refrigerator() {
    return (
        <svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_608_33155)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.1338 25.1824H6.17525C5.8132 25.1824 5.48539 25.0416 5.24683 24.813C5.00715 24.5833 4.8584 24.2642 4.8584 23.9115V2.65327C4.8584 2.31198 4.99761 2.00157 5.22438 1.7735C5.46406 1.53244 5.80141 1.38184 6.17525 1.38184H19.1338C19.5313 1.38184 19.8877 1.55194 20.1291 1.82118C20.3294 2.04437 20.4507 2.33473 20.4507 2.65327V23.9115C20.4507 24.2875 20.2812 24.6255 20.0129 24.8579C19.7794 25.0595 19.4718 25.1824 19.1338 25.1824Z"
                    stroke="black"
                    strokeWidth="0.961453"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7.7168 5.7373V7.28861" stroke="black" strokeWidth="0.961453" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M7.7168 13.248V16.0058" stroke="black" strokeWidth="0.961453" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M4.8584 10.375H20.4507" stroke="black" strokeWidth="0.961453" />
            </g>
            <defs>
                <clipPath id="clip0_608_33155">
                    <rect width="25.6387" height="25.6387" fill="white" transform="translate(0.212891 0.707031)" />
                </clipPath>
            </defs>
        </svg>
    );
}
